import BookingLayout from 'pages/booking/BookingLayout';
import useLang from 'lang';
import 'pages/booking/BookingNotFound.css';

/**
 * Non-revealing page used for unknown and non-public booking URLs.
 */
export default function BookingNotFound() {
  const { _t } = useLang();

  return (
    <BookingLayout>
      <main className="booking-not-found">
        <div>
          <p className="booking-not-found__code">404</p>
          <h1 className="booking-not-found__title">{_t('Booking page not found')}</h1>
          <p className="booking-not-found__message">{_t('The requested booking page does not exist.')}</p>
        </div>
      </main>
    </BookingLayout>
  );
}
